import { reducer as formReducer } from 'redux-form'

import { appConfigStateReducer } from '@tabeeb/modules/appConfigState'
import contentState from '@tabeeb/modules/shared/content/reducers'
import recording from '@tabeeb/modules/recording/reducers'
import chat from '@tabeeb/modules/chat/reducers'
import sessionTabsReducer from '@tabeeb/modules/sessionTabs/reducers'
import gridView from '@tabeeb/modules/gridView/reducers'
import callNotification from '@tabeeb/modules/callNotification/reducers'
import { calendarReducer as calendar } from '@tabeeb/modules/calendar'
import permissions from '@tabeeb/modules/permissions/reducers'
import { remindersReducer as reminders } from '@tabeeb/modules/reminders'
import discussion from '@tabeeb/modules/discussion/reducers'
import contentMetadata from '@tabeeb/modules/contentMetadata/reducers'
import { powerBIReducer as powerBI } from '@tabeeb/modules/powerBIReports'
import contentSharings from '@tabeeb/modules/contentSharings/reducers'
import classificationAnnotationsPagesTimeline from '@tabeeb/modules/classificationAnnotationsPagesTimeline/reducers'
import pointCloudGeoSearch from '@tabeeb/modules/pointCloudGeoSearch/reducers'
import contentTrashBin from '@tabeeb/modules/contentTrashBin/reducers'
import { mobileWhiteboardReducer as mobileWhiteboard } from '@tabeeb/modules/mobileWhiteboard'
import pointCloud from '@tabeeb/modules/pointCloud/reducers'
import healthData from '@tabeeb/modules/healthData/reducers'
import sncFilters from '@tabeeb/modules/sncFilters/reducers'
import { aiReportReducer as AIReport } from '@tabeeb/modules/aiReport'
import { reportTemplateEditorsReducer as reportTemplateEditor } from '@tabeeb/modules/reportTemplateEditor'
import { workflowsReducer as workflows } from '@tabeeb/modules/workflows'
import { utilityInfrastructureReducer as utilityInfrastructure } from '@tabeeb/modules/utilityInfrastructure'
import { powerBIReportProvidersReducer as powerBIReportProviders } from '@tabeeb/modules/powerBIReportProviders'
import splatModel from '@tabeeb/modules/splatModel/reducers'
import { importSpreadsheetsDialogReducer as importSpreadsheetsDialog } from '@tabeeb/modules/importSpreadsheetsDialog'
import { checkInsReducer as checkIns } from '@tabeeb/modules/checkIns'

import { selectionListsReducer as selectionLists } from '@tabeeb/modules/selectionLists'
import player from '../../modules/player/reducers'

import activities from '../../modules/activities/reducers'
import forms from '../../modules/forms/reducers'
import gallery from '../../modules/gallery/reducers'
import fileUploads from '../../modules/fileUploads/reducers'
import users from '../../users/reducers/index'
import presentation from '../../modules/presentation/reducers'
import playerToolbar from '../../modules/playerToolbar/reducers'
import customVideo from '../../modules/customVideo/reducers'
import presentationToolbar from '../../modules/presentationToolbar/reducers'
import { notificationReducer as notification } from '../../modules/notification'
import sessionsPage from '../../modules/sessionsPage/reducers'
import tenantForms from '../../modules/tenantForms/reducers'
import tenantConfigPage from '../../modules/tenantConfigPage/reducers'
import artificialIntelligence from '../../modules/artificialIntelligence/reducers'
import spatialModel from '../../modules/spatialModel/reducers'
import threedeeModel from '../../modules/3dmodel/reducers'

import contentViewer from '../../modules/contentViewer/reducers'
import bentleyModel from '../../modules/bentleyModel/reducers'
import bentleyAnalyticsReport from '../../modules/bentleyAnalyticsReport/reducers'

import tenantSessionsPage from '../../modules/tenantSessionsPage/reducers'
import policies from '../../modules/policies/reducers'
import shareSessionPagesList from '../../modules/shareSessionPagesList/reducers'
import account from '../../modules/account/reducers'
import admin from '../../modules/admin/adminReducer'
import notificationsPage from '../../modules/notificationsPage/reducers'
import tracking from '../../modules/tracking/reducers'
import alertOwner from '../../modules/alertOwner/reducers'
import reviewSessionPagesList from '../../modules/reviewSessionPagesList/reducers'
import contentReviews from '../../modules/contentReviews/reducers'
import { compassReducer as compass } from '../../modules/compass'

import annotations from '../../modules/annotations/reducers'
import { allFormsReducer as allForms } from '../../modules/allForms'

import whiteboard from '../../modules/whiteboard/reducers'

import sessionState from './sessionState'
import deviceState from './deviceState'

import modelTraining from '../../modules/modelTraining/reducers'

export default {
  account,
  activities,
  admin,
  AIReport,
  alertOwner,
  allForms,
  annotations,
  appConfigState: appConfigStateReducer,
  artificialIntelligence,
  bentleyAnalyticsReport,
  bentleyModel,
  calendar,
  callNotification,
  chat,
  checkIns,
  classificationAnnotationsPagesTimeline,
  compass,
  contentMetadata,
  contentReviews,
  contentSharings,
  contentState,
  contentTrashBin,
  contentViewer,
  customVideo,
  deviceState,
  discussion,
  fileUploads,
  form: formReducer,
  forms,
  gallery,
  gridView,
  healthData,
  mobileWhiteboard,
  modelTraining,
  navbar: sessionTabsReducer,
  notification,
  notificationsPage,
  permissions,
  player,
  playerToolbar,
  pointCloud,
  pointCloudGeoSearch,
  policies,
  powerBI,
  powerBIReportProviders,
  presentation,
  presentationToolbar,
  recording,
  reminders,
  reportTemplateEditor,
  reviewSessionPagesList,
  selectionLists,
  sessionsPage,
  sessionState,
  shareSessionPagesList,
  sncFilters,
  spatialModel,
  splatModel,
  tenantConfigPage,
  tenantForms,
  tenantSessionsPage,
  threedeeModel,
  tracking,
  users,
  utilityInfrastructure,
  whiteboard,
  workflows,
  importSpreadsheetsDialog,
  sessionTabsReducer,
}
